const clinicType = 'vet';
const isProd = process.env.REACT_APP_USER_API_URL.includes('prod');

const config = {
    clinicType,
    isProd,
    mixpanelToken: isProd
        ? 'cf4c559bb22f7ba78ba1667adc6bdbe4' // vet prod token
        : 'b9a4fc257db382b75fb35c9011ff6f98', // vet dev/staging token

    loginBanner: require('./assets/banners/loginPageBanner.png'),

    cetraBlueLogo: require('./assets/logos/cetra_blue.png'),

    cetraMobileLogo: require('./assets/logos/cetra_marque.png'),

    gtagId: process.env.REACT_APP_GTAG_ID || '',

    accountTypes: [
        {
            type: 'Student',
            title: "I'm a student",
            description: 'I am pursuing a degree/course in veterinary science or a related field involving animals.',
        },
        {
            type: 'Professional',
            title: "I'm a professional",
            description: 'I will use Cetra to enhance my work as an individual.',
        },
        {
            type: 'Clinic',
            title: "I'm the admin of a practice",
            description: 'I want to use Cetra to support and improve the care my practice delivers.',
        },
    ],

    feedbackText:
        'We highly appreciate detailed information, as it plays a crucial role in fulfilling our mission of improving animal welfare through comprehensive veterinary knowledge.',

    landingPageUrl: 'https://www.cetravets.com',

    surveyUrl: 'https://forms.office.com/e/10XN2xgEJm',

    tsCsUrl: 'https://www.cetravets.com/legal/terms-of-service',

    upgradeImages: {
        paywall: {
            clinic: require('./assets/banners/ctaUpgradeClinicPaywall.png'),
            professional: require('./assets/banners/ctaUpgradeProfessionalPaywall.png'),
        },
        settings: {
            clinic: {
                desktop: require('./assets/banners/ctaUpgradeClinic.png'),
                mobile: require('./assets/banners/ctaUpgradeClinicMobile.png'),
            },
            professional: {
                desktop: require('./assets/banners/ctaUpgradeProfessional.png'),
                mobile: require('./assets/banners/ctaUpgradeProfessionalMobile.png'),
            },
            trial: {
                desktop: require('./assets/banners/ctaUpgradeTrial.png'),
                mobile: require('./assets/banners/ctaUpgradeTrialMobile.png'),
            },
        },
    },

    practiceOrClinicText: 'practice',

    // annualDiscountText: 'Save 5% with annual plans',
};

export const getCTAUpgradeImageUrl = (type) => {
    return config.upgradeImages.paywall[type];
};

export const getCTAUpgradeSettingsImageUrl = (planType, isMobile = false) => {
    const viewPort = isMobile ? 'mobile' : 'desktop';
    return config.upgradeImages.settings[planType][viewPort];
};

export const cetraBlueLogo = config.cetraBlueLogo;
export const cetraMobileLogo = config.cetraMobileLogo;
export const feedbackMessage = config.feedbackText;
export const landingPageUrl = config.landingPageUrl;
export const surveyUrl = config.surveyUrl;
export const tsCsUrl = config.tsCsUrl;
export const practiceOrClinicText = config.practiceOrClinicText;

export default config;
